import { IsNotEmpty, IsUUID } from 'class-validator';

export class AcceptEventCommand {
  @IsNotEmpty()
  @IsUUID()
  id: string;
}
